import { render, staticRenderFns } from "./SkipLink.vue?vue&type=template&id=a80dbf3e&scoped=true&"
import script from "./SkipLink.vue?vue&type=script&lang=js&"
export * from "./SkipLink.vue?vue&type=script&lang=js&"
import style0 from "./SkipLink.vue?vue&type=style&index=0&id=a80dbf3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80dbf3e",
  null
  
)

export default component.exports